import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { LoaderService } from '@loader';
import { ClxPlantOverlayComponent } from './clx-plant-overlay.component';
import { MapServiceProvider, KpiService, MapServiceDummy } from '@geo';
import { CachedPromiseManager } from '@cache';
import { StateService, StateSubscription, States } from '@state';

@Component({
    selector: 'clx-status-map',
    template: `
        <clx-tab-navigation [disableIfOneTab]="true">
            <clx-tab-navigation-item
                [active]="mode === 'system'"
                test-id="status-map.system.tab.item.navi"
                title="Systems"
                i18n-title="@@status-map.tab-navi.system.title"
                route="/Home/StatusMap/Systems"
                [checkRoutePrivileges]="true"
            ></clx-tab-navigation-item>

            <clx-tab-navigation-item
                [active]="mode === 'plant'"
                test-id="status-map.plant.tab.item.navi"
                title="Plants"
                i18n-title="@@status-map.tab-navi.plant.title"
                route="/Home/StatusMap/Plants"
                [checkRoutePrivileges]="true"
            ></clx-tab-navigation-item>

        </clx-tab-navigation>
        <clx-row>
            <clx-item>
                <clx-select (change)="kpiChanged($event)" [values]="kpiSelect" test-id="map.select.kpis"></clx-select>
                @if(enableUITwo) {
                    <clx-button i18n="@@status-map.tab-navi.system.refresh.button" type="default"
                    class="simpl-icon-refresh secondary-button refresh-button" (click)="refreshKpis()" test-id="map.button.refresh">Refresh</clx-button>
                } @else {
                    <clx-button type="icon" class="fa fa-refresh" (click)="refreshKpis()" test-id="map.button.refresh"></clx-button>
                }
            </clx-item>
        </clx-row>
        <div #map class="status-map" test-id="map.content"></div>
        <clx-plant-overlay #overlay [mode]="mode"></clx-plant-overlay>
    `,
    providers: [MapServiceProvider],
    standalone: false
})
export class ClxStatusMapComponent {
    constructor(
        public service: MapServiceDummy,
        public kpiService: KpiService,
        public loaderService: LoaderService,
        public stateService: StateService,
    ){
        const themeConfig = this.stateService.value(States.themeConfig).get();
        this.enableUITwo = themeConfig.enableUITwo || false;
    }

    @ViewChild('map', { static: true })
    public mapElement: ElementRef;

    public enableUITwo: boolean = false;

    @ViewChild(ClxPlantOverlayComponent, { static: true })
    public overlay: ClxPlantOverlayComponent;

    public kpiSelect: any[] = [];

    private stateSubscription: StateSubscription;

    @Input()
    public mode: string = 'plant';

    private lastKpiKey: string = ''
    public async kpiChanged(kpiKey: any): Promise<string>{
        const loaderId = this.loaderService.start();
        kpiKey = await this.kpiService.selectKpi(kpiKey);
        // avoid map refresh if the kpiKey has not changed
        if (kpiKey && kpiKey !== this.lastKpiKey) {
            this.lastKpiKey = kpiKey;
            await this.service.refreshMap(kpiKey, this.mode);
        }
        this.loaderService.stop(loaderId);
        return kpiKey;
    }

    public async refreshKpis() {
        CachedPromiseManager.removeCache('map-data');
        await this.service.refreshMap(this.kpiService.selectedKpiId, this.mode);
    }

    public async ngAfterViewInit(){
        const loaderId = this.loaderService.start();
        try {
            const kpis = await this.kpiService.getKpis(this.mode);
            await this.service.init(this.mapElement.nativeElement, this.overlay);
            const kpiKey = await this.kpiChanged(null);
            this.kpiSelect = kpis.map((current) => {
                return {
                    value : current.key,
                    text : current.title,
                    selected : current.key === kpiKey ? 'selected' : null
                };
            });
        }catch(e){
            console.error('Some error occured while loading the map!', e);
            this.loaderService.stop(loaderId);
        }finally{
            this.loaderService.stop(loaderId);
        }
        this.stateSubscription = this.stateService.value(States.selectedSubtenants).subscribe(() => {
            if(this.lastKpiKey) {
                // if the selected Tenants change delete cache and reload data
                CachedPromiseManager.removeCache('map-data');
                this.service.refreshMap(this.lastKpiKey, this.mode);
            }
        })
    }

    public ngOnDestroy(){
        CachedPromiseManager.removeCache('map-data');
        this.service.reset();
        this.stateService.unsubscribe(this.stateSubscription);
    }
}
